export enum OFMProductTypes {
  RETENTION = 'bep.ofm.prices.retention',
  RETENTION_OFFER = 'bep.ofm.prices.retention-offers',
}
